import { useEffect, useState } from "react"

import { Flex, Modal, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import TextAreaComponent from "../../../../Components/Input/TextArea"
import SelectComponent from "../../../../Components/Select"
import Icon from "../../../../Icon"

import styles from "./ChangeStatusModal.module.less"

const { Text } = Typography

export const ChangeStatusModal = ({ open, onCancel, onApprove, loading, reasonOptions = [] }) => {
  const { t } = useTranslation()
  const isMobile = useSelector((state) => state.nav.isMobile)

  const [reason, setReason] = useState(null)
  const [details, setDetails] = useState("")

  useEffect(() => {
    if (!open) {
      setReason(null)
      setDetails("")
    }
  }, [open])

  return (
    <Modal
      open={open}
      centered={!isMobile}
      width={442}
      title={t("Change access request status")}
      footer={null}
      onCancel={onCancel}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
      closeIcon={<Icon type="cross_small" />}
      getContainer={() => document.getElementById("main-layout")}
    >
      <Flex vertical gap={24}>
        <Text type="secondary">
          {t(
            "Are you sure you want to change the Access Request status to Attention needed? Select the reason and click Apply button"
          )}
        </Text>

        <Flex vertical gap={8}>
          <Text strong>
            {t("Reason")} <Text type="danger">*</Text>
          </Text>
          <SelectComponent
            size="large"
            placeholder={t("Select a reason")}
            value={reason}
            onChange={setReason}
            options={reasonOptions}
          />
        </Flex>

        <Flex vertical gap={8}>
          <Text strong>{t("Add details")}</Text>
          <TextAreaComponent
            rows={3}
            placeholder={t("Write details (optional)...")}
            value={details}
            onChange={(e) => setDetails(e.target.value)}
          />
        </Flex>
      </Flex>

      <Flex gap={12} justify="end" className={styles.footer}>
        <ButtonComponent size="large" onClick={onCancel}>
          {t("Cancel")}
        </ButtonComponent>
        <ButtonComponent
          size="large"
          type="primary"
          disabled={!reason}
          loading={loading}
          onClick={() => onApprove({ reason, details })}
        >
          {t("Approve")}
        </ButtonComponent>
      </Flex>
    </Modal>
  )
}

export default ChangeStatusModal
